import { useGet } from '../../HttpClient';
import { useQueryWithErrorHandling } from '../../../hooks/UseQueryWithErrorHandling';
import { useQueryClient } from '@tanstack/react-query';

import { Account } from '@app/models';

export function useAccountById(id: string) {
  const get = useGet(true, "ams");
  const getAccountById = (accountId: string) => {
    return get<Account>(`/api/proxy/ams/account-service/account/${accountId}`);
  };

  return useQueryWithErrorHandling({
    queryKey: ['accountById', id],
    queryFn: () => getAccountById(id),
    enabled: !!id,
  });
}

export function useRefreshAccountId(id: string) {
  const queryClient = useQueryClient();
  return () => {
    queryClient.refetchQueries({ queryKey: ['accountById', id] })
  }
}
